import { ROUTE_MICROSOFT_REDIRECT } from "@/constants/routes";

const CLIENT_ID = '5671ca05-9cc8-481e-8016-601cd4264e21';

/**
 * We cannot use the fucking microsoft SDK. So we have done this manual implementation :/
 */
function syncCalendars() {
	const scopes = ['offline_access', 'User.Read', 'Calendars.ReadWrite'];

	const microsoftOauthURL = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize');

	microsoftOauthURL.searchParams.set('client_id', CLIENT_ID);
	microsoftOauthURL.searchParams.set('scope', scopes.join(' '));
	microsoftOauthURL.searchParams.set('redirect_uri', `${window.location.origin}${ROUTE_MICROSOFT_REDIRECT}`);
	microsoftOauthURL.searchParams.set('response_mode', 'query');
	microsoftOauthURL.searchParams.set('response_type', 'code');
	microsoftOauthURL.searchParams.set('state', window.location.pathname);

	return window.open(microsoftOauthURL.toString());
}

export default {
	syncCalendars,
};
